import React, { useEffect } from 'react'
import FullReset from '../components/Settings/FullReset'
import { useAppLayoutResetter } from '@caudena/core/state'

export const PageFullReset = () => {
  const resetLayout = useAppLayoutResetter()
  useEffect(() => {
    resetLayout()
  }, [])
  return <FullReset />
}

export default PageFullReset
